import React from 'react';
import styled from 'styled-components/native';
import { AppImageView } from '@/components/base/app.image.view';
import { useAssets } from '@/hooks/use.assets';
import { Box } from '@/components/base/box';

interface Props {
  onReject?: () => void;
  onAccept?: () => void;
  state: 'transmitting' | 'initiating';
}
function BaseAnswerButtonsView({ state, onAccept, onReject }: Props) {
  const assets = useAssets();
  return (
    <Container $state={state}>
      {onAccept && <IconButton onPress={onAccept} source={assets.images.answer_call} />}
      {onReject && <IconButton onPress={onReject} source={assets.images.hang_up} />}
    </Container>
  );
}

const IconButton = styled(AppImageView)`
  width: 50px;
  height: 50px;
`;

const Container = styled(Box)<{ $state: 'transmitting' | 'initiating' }>`
  width: ${({ theme }) => theme.wp(100)}px;
  bottom: ${({ theme, $state }) => ($state === 'transmitting' ? theme.hp(17) : theme.hp(10))}px;
  flex-direction: row;
  align-items: center;
  z-index: 2;
  justify-content: space-evenly;
  position: absolute;
`;

export const AnswerButtonsView = React.memo(BaseAnswerButtonsView);
